// extracted by mini-css-extract-plugin
export default {"questionarie":"Questionarie_questionarie__N3-sp","btns":"Questionarie_btns__uXsev","btn":"Questionarie_btn__hBe+-"};